import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { parseToIsoDate } from '../../utils/dateFormat';
import MonthCalendarPanel from './MonthCalendarPanel';

type Props = {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  minDate?: string;
  maxDate?: string;
  enableYmdViews?: boolean;
};

export default function DualMonthRangeCalendar({ from, to, onChange, minDate, maxDate, enableYmdViews = false }: Props) {
  const fromIso = from ? parseToIsoDate(from) : '';
  const anchorIso = fromIso || dayjs().format('YYYY-MM-DD');

  const [leftMonth, setLeftMonth] = useState(() => dayjs(anchorIso).startOf('month'));
  const rightMonth = leftMonth.add(1, 'month');

  useEffect(() => {
    if (!fromIso) return;
    const m = dayjs(fromIso).startOf('month');
    setLeftMonth(m);
  }, [fromIso]);

  const handleDaySelect = (iso: string) => {
    if (!fromIso || (fromIso && to)) {
      onChange(iso, '');
      return;
    }
    if (iso < fromIso) onChange(iso, fromIso);
    else onChange(fromIso, iso);
  };

  return (
    <div className="cal-dual">
      <MonthCalendarPanel
        month={leftMonth}
        onMonthChange={(m) => setLeftMonth(m.startOf('month'))}
        rangeFrom={fromIso}
        rangeTo={to ? parseToIsoDate(to) : ''}
        onDaySelect={handleDaySelect}
        minDate={minDate}
        maxDate={maxDate}
        enableYmdViews={enableYmdViews}
      />
      <MonthCalendarPanel
        month={rightMonth}
        onMonthChange={(m) => setLeftMonth(m.subtract(1, 'month').startOf('month'))}
        rangeFrom={fromIso}
        rangeTo={to ? parseToIsoDate(to) : ''}
        onDaySelect={handleDaySelect}
        minDate={minDate}
        maxDate={maxDate}
        enableYmdViews={enableYmdViews}
      />
    </div>
  );
}
